// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1o-FK","resendInfoText":"OnGoingPaymentBox_resendInfoText__2r5s_"};